import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import DateField from "../../../components/Fields/DateField";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { UserPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";
import FormatUtils from "../../../utils/FormatUtils";

interface UserOutOfOfficeModel {
    id?: number
    userId: number
    beginDate: string
    endDate?: string
    replacedByUserId?: number
    concurrencyId?: string
}

const AddUserOutOfOfficePopup: React.FC<UserPopupProps> = ({ show, onHide, userId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<UserOutOfOfficeModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const users = useSelectListOptions('api/v1/selectlist/Users?activeOnly=true', '-- Select replacement');

    const [formData, setFormData] = useState<UserOutOfOfficeModel>({
        userId: userId,
        beginDate: new FormatUtils().formatDateForStorage(new Date()),
    });

    useEffect(() => {
        DataService.get<UserOutOfOfficeModel>(`api/v1/users/${userId}/outOfOffice/`)
            .then(response => {
                if (response) {
                    setFormData({ ...response })
                }
            })
    }, [userId]);

    function submit() {
        if (formData) {
            if (formData.id)
                DataService
                    .update<UserOutOfOfficeModel>(`api/v1/Users/OutOfOffice`, formData)
                    .then(response => {
                        handleResult(response);
                        setServerErrors(response);
                        if (response.isSuccesful === true) {
                            if (onHide)
                                onHide();
                        }
                    })
                    .catch(e => handleException(e));
            else
                DataService
                    .create<UserOutOfOfficeModel>(`api/v1/Users/OutOfOffice`, formData)
                    .then(response => {
                        handleResult(response);
                        setServerErrors(response);
                        if (response.isSuccesful === true) {
                            if (onHide)
                                onHide();
                        }
                    })
                    .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'beginDate', label: 'From', labelSize: 2, validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Until', labelSize: 2, validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'replacedByUserId', label: 'Replacement', labelSize: 2 },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Out-of-Office'} >
            <Popup.Body>
                <DateField {...getFieldProps('beginDate')} />
                <DateField {...getFieldProps('endDate')} />
                <SelectListField {...getFieldProps('replacedByUserId')} options={users} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddUserOutOfOfficePopup;